import type { AnthropicBucketWidth } from './types';
import type { UsageReportParams } from '../anthropic-api';

export const CONSOLE_KEY_ID = 'anthropic-console-usage';
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const TOKENS_PER_REQUEST_CLAUDE_CODE = 25_000;
export const TOKENS_PER_REQUEST_API = 5_000;
/** Discount weight for cache_read tokens in request estimation.
 *  cache_read correlates with request count but also scales with context size,
 *  so we count only a fraction to avoid over-estimation. */
export const CACHE_READ_REQUEST_WEIGHT = 0.1;
export const ANTHROPIC_USAGE_SEGMENT_CACHE_VERSION = '2026-06-10-segment-v6'; // inference_geo を撤回（group_by は最大5次元）
// 注意: usage_report の group_by は最大 5 次元（超えると 400）。
// inference_geo は枠の都合で外している（us geo の 1.1x は日次の cost_report 補正で吸収される）。
export const ANTHROPIC_GROUP_BY: NonNullable<UsageReportParams['group_by']> = ['model', 'workspace_id', 'api_key_id', 'speed', 'service_tier'];
export const ANTHROPIC_SEGMENT_CACHE_TTL_RECENT_MS = 15 * 60 * 1000;
export const ANTHROPIC_SEGMENT_CACHE_TTL_HISTORICAL_MS = 180 * 24 * 60 * 60 * 1000;
export const DAY_SECONDS = 24 * 60 * 60;

export const BUCKET_SECONDS_BY_WIDTH: Record<AnthropicBucketWidth, number> = {
  '1m': 60,
  '1h': 60 * 60,
  '1d': 24 * 60 * 60
};

export const MAX_BUCKETS_BY_WIDTH: Record<AnthropicBucketWidth, number> = {
  '1m': 1440,
  '1h': 168,
  '1d': 31
};

export const padNumber = (value: number): string => value.toString().padStart(2, '0');

export const formatUtcDateKey = (date: Date): string => (
  `${date.getUTCFullYear()}-${padNumber(date.getUTCMonth() + 1)}-${padNumber(date.getUTCDate())}`
);

export const formatUtcHourKey = (date: Date): string => (
  `${formatUtcDateKey(date)} ${padNumber(date.getUTCHours())}:00:00`
);

export const formatUtcMinuteKey = (date: Date): string => (
  `${formatUtcDateKey(date)} ${padNumber(date.getUTCHours())}:${padNumber(date.getUTCMinutes())}:00`
);

export const formatUtcBucketKey = (date: Date, bucketWidth: AnthropicBucketWidth): string => {
  if (bucketWidth === '1m') {
    return formatUtcMinuteKey(date);
  }
  if (bucketWidth === '1h') {
    return formatUtcHourKey(date);
  }
  return formatUtcDateKey(date);
};

export const delay = (ms: number): Promise<void> => new Promise<void>(resolve => setTimeout(resolve, ms));
